import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class ReportOverviewModule {
    static defineRoute(path: string): Route {
        return {
            path,
            loadChildren: () =>
                import('app/report-overview/report-overview.lazy.module').then(
                    (m) => m.ReportOverviewLazyLoadedModule,
                ),
        };
    }
}
